import { useSyncExternalStore } from 'react';
import { websocketStore } from './websocketStore';

// Each component now reads exactly the same value.
export function useWebsocketConnection(): [
  { url: string; timestamp: number } | null,
  (url: string) => void,
  () => void,
] {
  const value = useSyncExternalStore(
    websocketStore.subscribe,
    websocketStore.get,
  );

  return [value, websocketStore.set, websocketStore.clear];
}
